import { render } from "./ArtistList.vue?vue&type=template&id=4d1126f9&scoped=true"
import script from "./ArtistList.vue?vue&type=script&lang=js"
export * from "./ArtistList.vue?vue&type=script&lang=js"

import "./ArtistList.vue?vue&type=style&index=0&id=4d1126f9&scoped=true&lang=css"

import exportComponent from "/Users/juvicmartires/Documents/BreakingHits/breakinghits-vuejs-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d1126f9"]])

export default __exports__